import Box from '@mui/material/Box';

function CustomHelpPopover({ content, title = '' }) {
    return (
        <Box sx={{ backgroundColor: '#fff', maxWidth: '276px', minWidth: '200px', wordWrap: 'break-word' }}>
            <Box sx={{ padding: '8px 14px', marginBottom: '0', fontSize: '14px', fontWeight: 'bold', lineHeight: '18px', backgroundColor: '#f7f7f7', borderBottom: '1px solid #ebebeb', borderRadius: '5px 5px 0 0', color: '#1e88e9' }}>
                {title}
            </Box>
            <Box sx={{ padding: '9px 14px', fontSize: '13px', lineHeight: '1.42857143', color: '#333', wordWrap: 'break-word' }}>
                <Box dangerouslySetInnerHTML={{ __html: content }} />
            </Box>
        </Box>
    );
}

export default CustomHelpPopover;
